import type { SVGProps } from "react";
export function TwitterX(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1024 1024"
            {...props}
        >
            <path
                fill="currentColor"
                d="M1024 512c0 282.769-229.23 512-512 512s-512-229.23-512-512c0-282.769 229.23-512 512-512s512 229.23 512 512z"
            />
            <path
                fill="#fff"
                d="M196.607 215.363l244.73 327.221-246.273 266.047h55.431l215.615-232.934 174.205 232.934h188.618l-258.505-345.624 229.231-247.644h-55.431l-198.565 214.521-160.441-214.521h-188.618zM278.12 256.188h86.65l382.641 511.617h-86.65l-382.641-511.617z"
            />
        </svg>
    );
}
